import { AnalyticsAdapter, EventBase } from '@lifeway/frontend-analytics';
import apiClient from '../../../services/apiClient';
import { logger } from '../../../utils/logger';
import { PurchaseInitiatedEvent } from '../events/license/purchaseInitiatedEvent';

export class ActiveCampaignAdapter implements AnalyticsAdapter {
  private trackEvent(eventName: string, email: string) {
    const data = { event: {}, eventName, email };
    logger.debug('ActiveCampaign.trackEvent called with', data);

    if (window.config?.activeCampaignEnabled) {
      return apiClient.post('/trackingAC', data);
    }
    return Promise.resolve();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public emit(...events: EventBase<any, any, any>[]): Promise<unknown> {
    return Promise.allSettled(
      events
        .map(event => {
          switch (event.constructor) {
            case PurchaseInitiatedEvent: {
              return this.trackEvent(`Carted_${event.context.itemNumber}`, event.context.userEmail);
            }
            default:
              return;
          }
        })
        .filter(Boolean)
    );
  }

  public log(): void {}
  public unloadPage(): void {}
  public updatePage(): void {}
  public viewPage(): void {}
  public anonymize(): Promise<void> {
    return Promise.resolve();
  }
  public identify(): Promise<void> {
    return Promise.resolve();
  }
}
